import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[bsVisiblePassword]',
  exportAs: 'bsVisiblePassword',
})
export class FeaturesVisiblePasswordDirective {
  inputType = 'password';
  iconName = 'visibility_off';
  isVisible = false;

  @HostListener('click') updateProperties() {
    this.isVisible = !this.isVisible;
    this.inputType = this.isVisible ? 'text' : 'password';
    this.iconName = this.isVisible ? 'visibility' : 'visibility_off';
  }
}
